<template>
  <div class="badge">
    <el-popover class="badge-popover" popper-class="popperClass" :content="text" placement="top" width="150"
      trigger="hover">
      <div slot="reference" class="badge-big" :style="{'background-image': 'url('+selectIcon+')'}" @click="mark"></div>
    </el-popover>
  </div>
</template>

<script>
  import selectIcon from '@/assets/select.png'
  export default {
    name: 'angleMarkText',
    props: {
      text: {
        type: String,
        default: '未添加问题标签'
      }
    },
    data() {
      return {
        selectIcon
      }
    },
    methods: {
      mark() {
        this.$emit('mark')
      }
    }
  }
</script>

<style scoped lang="scss">
  .badge {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    z-index: 99;
    cursor: pointer;
  }

  .badge-popover {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .popperClass {
    background-color: rgba(0, 0, 0, .5);
  }

  .badge-big {
    position: relative;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/AngleMark.vue